import React, { useState } from 'react'
import { IMenuItem } from 'hooks/useMenu'
import { Button } from '@material-ui/core'
import { Link } from 'components/ui/Behaviors/Link'
import { useStyles } from './SmallScreenNavigationItem.styles'
import clsx from 'clsx'
import { Title } from '../../../Typography/Title'
import { KeyboardArrowRight } from '@material-ui/icons'

export interface ISubMenuProps {
  title: string
  menuItems: IMenuItem[]
}

export const SubMenu = ({ title, menuItems }: ISubMenuProps) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={classes.line}>
      <Button onClick={() => setIsOpen(!isOpen)} className={clsx(classes.root)}>
        <Title>{title}</Title>
        <KeyboardArrowRight className={clsx(classes.arrow, isOpen && classes.open)} />
      </Button>
      {isOpen && (
        <div className={classes.subItemWrapper}>
          {menuItems.map((item) => (
            <Link route={item.link || '/'}>
              <Title>{item.title}</Title>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
